import React, { useState } from 'react'
import { Layout, Popover, Tag } from 'antd'
import { Link } from 'react-router-dom'
import IntlMessages from '../../util/IntlMessages'
import CustomScrollbars from '../../util/CustomScrollbars'
import languageData from './languageData'
import {
  switchLanguage,
  toggleCollapsedSideNav
} from '../../appRedux/actions/Setting'
import SearchBox from '../../components/SearchBox/index'
import UserInfo from '../../components/UserInfo/index'
import Auxiliary from '../../util/Auxiliary'
import DataServices from '../../Services/DataServices'
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  TAB_SIZE
} from '../../constants/ThemeSetting'
import { useDispatch, useSelector } from 'react-redux'
import { isMobile } from 'react-device-detect'
import { BUS_PARENT_SITE } from '../../constants/StoreSetting'
import {
  GetIndexDBDataByTableName,
  saveEntitiesDatatoIndexBD
} from '../../appRedux/actions/IndexDBActions'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES
} from '../../constants/IndexDBData'
import { CONFIG_LOGS } from '../../constants/IndexDB_Logs'
import BuzzTillBannerLogo from '../../assets/images/BUZZTILL_logo_500px.png'
import { IdcardOutlined, ShopOutlined } from '@ant-design/icons'

const { Header } = Layout

const Topbar = () => {
  const dispatch = useDispatch()

  const { locale, width, navCollapsed, navStyle } = useSelector(
    ({ settings }) => settings
  )
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const showHeaderFooter = useSelector(
    ({ commonConfigs }) => commonConfigs.showHeaderFooter
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const { searchText, setSearchText } = useState('')
  const [languageDataObj, setLanguageData] = React.useState([])
  const [getRegName, setRegName] = useState('')
  const [getOutletName, setOutletName] = useState('')
  const [isOutletShow, setOutletShow] = useState(false)
  const [showHeader, setShowHeader] = useState(true)

  React.useEffect(() => {
    if (isOnline) getLanguageData()
    else getLangFromIndex()
  }, [isOnline])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      // NOTE: This check is only to hide header for cart page
      if (window.location.pathname.toLowerCase().includes('/sell/mainsale')) {
        if (showHeaderFooter) {
          setShowHeader(true)
        } else setShowHeader(false)
      } else setShowHeader(true)

      if (window.location.pathname.toLowerCase().includes('/sell')) {
        setOutletShow(true)
        if (getReduxSelectedStoreOutlets.id) {
          setOutletName(
            getReduxSelectedStoreOutlets && getReduxSelectedStoreOutlets.outlet
              ? getReduxSelectedStoreOutlets.outlet
              : ''
          )
        } else {
          let selectedLocalOut = localStorage.getItem('selectedOut')
          if (selectedLocalOut) {
            selectedLocalOut = JSON.parse(selectedLocalOut)
            setOutletName(
              selectedLocalOut && selectedLocalOut.outlet
                ? selectedLocalOut.outlet
                : ''
            )
          } else {
            setOutletName('')
          }
        }

        if (getReduxSelectedOutletReg.id) {
          setRegName(
            getReduxSelectedOutletReg && getReduxSelectedOutletReg.register
              ? getReduxSelectedOutletReg.register
              : ''
          )
        } else {
          let selectedReg = localStorage.getItem('selectedReg')
          if (selectedReg) {
            selectedReg = JSON.parse(selectedReg)
            setRegName(
              getReduxSelectedOutletReg.register
                ? getReduxSelectedOutletReg.register
                : selectedReg.register
            )
          } else {
            setRegName('')
          }
        }
      } else {
        setOutletShow(false)
        setOutletName('')
        setRegName('')
      }

      return () => (mounted = false)
    }
  }, [
    getReduxSelectedStoreOutlets,
    getReduxSelectedOutletReg,
    window.location.pathname,
    showHeaderFooter
  ])

  async function getLanguageData () {
    const getLanguageData = DataServices.getLanguages()
    await getLanguageData
      .then(async response => {
        setLanguageData(response.data.data)
        if (response.data.data) {
          let index_body = {
            config_key: CONFIG_LOGS.LANG,
            data: JSON.stringify(response.data.data)
          }
          await saveEntitiesDatatoIndexBD(
            [index_body],
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.CONFIGDATA,
            'getLanguageData'
          )
        }
      })
      .catch(ex => {
        console.log('lang error api')
        console.log(ex)
      })
  }

  function getLangFromIndex (dispatch) {
    const data = GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.CONFIGDATA
    )
    data
      .then(e => {
        if (e && e.length > 0) {
          const dataExist = e.filter(er => er.config_key == CONFIG_LOGS.LANG)
          if (dataExist && dataExist.length > 0 && dataExist[0].data) {
            setLanguageData(JSON.parse(dataExist[0].data))
          }
        } else {
          console.error(
            'INDEX_DB_DATA_NOT_FOUND -> INDEX_DB_TABLES.CONFIGDATA -->',
            e
          )
        }
      })
      .catch(e => {
        console.error('INDEX_DB_CONFIGS_ERROR -> getLangFromIndex -->', e)
      })
  }

  const languageMenu = () => {
    return (
      <CustomScrollbars className='gx-popover-lang-scroll-custom'>
        <ul className='gx-sub-popover'>
          {languageDataObj &&
            languageDataObj.length > 0 &&
            languageDataObj.map(language => (
              <li
                className='gx-media gx-pointer'
                key={JSON.stringify(language)}
                onClick={e => dispatch(switchLanguage(language))}
              >
                <i className={`flag flag-24 gx-mr-2 flag-${language.icon}`} />
                <span className='gx-language-text'>{language.name}</span>
              </li>
            ))}
        </ul>
      </CustomScrollbars>
    )
  }

  return (
    showHeader && (
      <Header>
        {navStyle === NAV_STYLE_DRAWER ||
        ((navStyle === NAV_STYLE_FIXED ||
          navStyle === NAV_STYLE_MINI_SIDEBAR) &&
          width < TAB_SIZE) ? (
          <div className='gx-linebar gx-mr-3'>
            <i
              className='gx-icon-btn icon icon-menu'
              onClick={() => {
                dispatch(toggleCollapsedSideNav(!navCollapsed))
              }}
            />
          </div>
        ) : null}

        <Link to='/' className='gx-d-block  gx-pointer'>
          {/* className='gx-d-block gx-d-lg-none   gx-pointer' */}
          {/* <img
            alt=''
            src={`${BUS_PARENT_SITE}/wp-content/uploads/2019/11/dakar-logo-150.png`}
            style={{ maxWidth: 61 }}
          /> */}
          {/* <img src={BuzzTillBannerLogo} className='header-logo-div' />  */}
        </Link>

        {/* {isMobile ? (
          <></>
        ) : (
          <>
            {isOutletShow ? (
              <>
                <div className='Store-Details-div'>
                  <div className='outlet-register-box'>
                  <p>
                    <ShopOutlined /> Outlet{' '}
                  </p>
                  <p style={{}}>{` "${
                    getOutletName ? getOutletName : '--'
                  }"`}</p>
                  </div>

<div className='outlet-register-box'>
                  <p>
                    <IdcardOutlined /> Register{' '}
                  </p>

                  <p style={{}}>{` "${getRegName ? getRegName : '--'}"`}</p>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </>
        )} */}
        {isOutletShow ? (
          <>
            <div className='Store-Details-div'>
              <div className='outlet-register-box'>
                <p>
                  <ShopOutlined /> Outlet{' '}
                </p>
                <p style={{}}>{` "${getOutletName ? getOutletName : '--'}"`}</p>
              </div>

              <div className='outlet-register-box'>
                <p>
                  <IdcardOutlined /> Register{' '}
                </p>

                <p style={{}}>{` "${getRegName ? getRegName : '--'}"`}</p>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}

        <ul className='gx-header-notifications  salis gx-ml-auto'>
          <li className='gx-language'>
            <Popover
              overlayClassName='gx-popover-horizantal'
              placement='bottomRight'
              content={languageMenu()}
              trigger='click'
            >
              <span className='gx-pointer gx-flex-row gx-align-items-center'>
                <i className={`flag flag-24 flag-${locale.icon}`} />
                <span className='gx-pl-2 gx-language-name'>{locale.name}</span>
                <i className='icon icon-chevron-down gx-pl-2' />
              </span>
            </Popover>
          </li>

          {getReduxStoreInfo && getReduxStoreInfo.userName && (
            <li className='gx-language user-name-div'>
              <li className='gx-language'>{getReduxStoreInfo.userName}</li>
              <li className='gx-language role-div' style={{}}>
                {getReduxStoreInfo.roleName}
              </li>
            </li>
          )}

          {/* <li className="gx-language">
          <li className="gx-language">
            <IntlMessages id="topbar.help" />
          </li>
        </li> */}

          {/* {width >= TAB_SIZE ?
          <li className="gx-notify">

            <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={""}
              trigger="click">
              <span className="gx-pointer gx-d-block"><i className="icon icon-notification" /></span>
            </Popover>
          </li> : null} */}

          {width >= TAB_SIZE ? (
            <li className='gx-user-nav'>
              <UserInfo />
            </li>
          ) : null}

          {width >= TAB_SIZE ? null : (
            <Auxiliary>
              <li className='gx-notify'>
                <Popover
                  overlayClassName='gx-popover-horizantal'
                  placement='bottomRight'
                  content={''}
                  trigger='click'
                >
                  <span className='gx-pointer gx-d-block'>
                    <i className='icon icon-notification' />
                  </span>
                </Popover>
              </li>
            </Auxiliary>
          )}

          {width >= TAB_SIZE ? null : (
            <Auxiliary>
              <li className='gx-user-nav'>
                <UserInfo />
              </li>
            </Auxiliary>
          )}
        </ul>
      </Header>
    )
  )
}

export default Topbar
